import { ref } from 'vue';
import { MilestoneHelper } from '../helpers/milestone.helper';
import type { ActionPlan, Milestone } from '../types/action-plan';

export function useActionPlan() {
  const showCompletedMilestones = ref(false);
  const activeMilestone = ref(null);

  const setActiveMilestone = (id: string) => {
    activeMilestone.value = id;
  };

  const filterMilestones = (milestones: Milestone[]) => {
    if (!milestones) {
      return [];
    }
    if (showCompletedMilestones.value) {
      return milestones;
    }

    return milestones.filter(milestone => !MilestoneHelper.isCompleted(milestone));
  };

  const toggleCompleted = () => {
    showCompletedMilestones.value = !showCompletedMilestones.value;
  };

  const getMilestoneOrder = (milestoneId: string, milestones: Milestone[]) => {
    if (!milestones || milestones.length === 0) {
      return;
    }
    return milestones.findIndex(milestone => milestone.id === milestoneId) + 1;
  };

  const hasMilestones = (actionPlan: ActionPlan) => actionPlan.milestones?.length > 0;

  const isActionPlanCompleted = (actionPlan: ActionPlan) => {
    const { milestones } = actionPlan;
    if (!milestones || milestones.length === 0) {
      return false;
    }
    return milestones.every(milestone => MilestoneHelper.isCompleted(milestone));
  };

  return {
    showCompletedMilestones,
    activeMilestone,
    isActionPlanCompleted,
    filterMilestones,
    hasMilestones,
    setActiveMilestone,
    toggleCompleted,
    getMilestoneOrder,
  };
}
